import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        position: 'relative',
        lineHeight: theme.typography.pxToRem(30),
        backgroundColor: theme.palette.secondary.main,
        textAlign: 'center',
        borderRadius: '4px',
        zIndex: 1,

        '&::after': {
            content: '""',
            position: 'absolute',
            left: '4.5em',
            bottom: '-3.5em',
            borderColor: `${theme.palette.secondary.main} transparent transparent transparent`,
            borderWidth: '2rem',
            borderStyle: 'solid',
            zIndex: 0
        }
    },
    label: {
        color: theme.palette.common.white,
        padding: '1em 0.5em',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        verticalAlign: 'middle',
        '& span': {
            flex: '100%'
        }
    },
    date: {
        opacity: 0.6
    },
    barValue: {
        opacity: 1,
        fill: theme.palette.common.white
    },
    subtext: {
        textTransform: 'lowercase',
        opacity: 0.6
    }
}));

export default useStyles;
